;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { ValidateTokenRequest } from '@qogita/canary-client'
import { CanaryClient } from '@qogita/deprecated-canary-client'
import { queryOptions } from '@tanstack/react-query'
import { SELLERS_CANARY_APPLICATION } from 'src/core/canary-application'
import { replaceUndefinedValuesWithNull } from 'src/deprecated/api/utilities'
import { getPrivateQueryKey } from 'src/deprecated/utils/queryKey'

export const AUTH_QUERY_KEYS = [...getPrivateQueryKey(), 'auth'] as const

const authCanaryClient = new CanaryClient({
  prefixUrl: '/api/',
  xQogitaApplication: SELLERS_CANARY_APPLICATION,
})
export function getAuthQueries(canaryClient: CanaryClient) {
  const queries = {
    refreshToken: () =>
      queryOptions({
        queryKey: AUTH_QUERY_KEYS,
        queryFn: async () => await authCanaryClient.refreshToken(),
      }),
    allTokenValidations: () =>
      [...AUTH_QUERY_KEYS, 'token-validation'] as const,
    validateToken: (data: ValidateTokenRequest) =>
      queryOptions({
        queryKey: [
          ...queries.allTokenValidations(),
          replaceUndefinedValuesWithNull(data),
        ],
        queryFn: async () => await canaryClient.validateToken(data),
      }),
  }

  return queries
}
